import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

export default createUseStyles({
  
  background: {
    backgroundImage: props => props.banner && `url(${props.banner})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: props => (props.siteId ? '60%' : '35%'),
    
    [MediaQueries.phone]: {
      width: '100% !important',
      paddingTop: props => (props.siteId ? '50%' : '60%'), // To make space for image
    },
  },
});
